<template>
  <v-row>
    <v-overlay :value="isProcessing">
      <v-progress-circular
        indeterminate
        color="primary"
        :size="70"
        :width="7"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="isFrozen" width="500">
      <v-card class="non-unique-modal">
        <v-card-title>
          <div />
          <h2>Uh-oh.</h2>
          <button @click="() => isFrozen = false">
            <v-icon>mdi-close</v-icon>
          </button>
        </v-card-title>
        <p>It looks like your account needs to be activated by your parent, you can do that <a @click="activateAccount">here</a>.</p>
      </v-card>
    </v-dialog>
    <v-col md="5" class="pb-0 hidden-sm-and-down">
      <v-img
        class="sticky-image"
        height="100vh"
        src="../../assets/register-dog.png"
      />
    </v-col>
    <v-col class="register pb-0" md="7" sm="12">
      <v-img height="10rem" class="my-3" contain src="../../assets/logo.svg" />
      <v-form class="login-form" v-model="isValid" @keyup.native.enter="isValid && submit()">
        <p>
          Welcome to the Australian Shepherd Club of America portal. You must be
          signed into your web access account in order to access the search
          feature and other resources for ASCA online. Please log in to view
          your information.
        </p>
        <v-text-field
          outlined
          v-model="username"
          label="Username"
          :rules="[(v) => !!v || 'Username is required']"
        ></v-text-field>
        <v-text-field
          outlined
          v-model="password"
          type="password"
          label="Password"
          :rules="[(v) => !!v || 'Password is required']"
        ></v-text-field>
        <v-alert
          width="100%"
          v-model="isError"
          dismissible
          type="error"
        >
          {{ errorMessage }}</v-alert
        >
        <router-link to="/forgotpassword">Forgot Password?</router-link>&nbsp;&nbsp;&nbsp;
        <router-link to="/forgotusername">Forgot Username?</router-link>
        <v-row justify="center" class="mt-1 mb-1">
          <v-checkbox
            v-model="rememberLogin"
            label="Remember My Login"
          ></v-checkbox>
        </v-row>
        <v-btn
          :disabled="!isValid || isProcessing"
          v-on:click="submit"
          large
          color="primary"
          class="mb-5"
          >Login</v-btn
        >
        <p>Don't have an ASCA Web Account yet?</p>
        <p><router-link to="/link-user-membership">Enroll Now</router-link></p>
      </v-form>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from "vue";
import authenticationService from "../../services/authenticationService";
import decodeToken from "@/helpers/decode-token";

export default Vue.extend({
  name: "Login",
  data: function () {
    return {
      username: "",
      password: "",
      rememberLogin: false,
      isValid: true,
      isProcessing: false,
      errorMessage: "",
      isError: false,

      isFrozen: false,
      frozenResponse: {},
    };
  },
  created() {
    const rememberMe = JSON.parse(localStorage.getItem("rememberMe") || "false");
    this.rememberLogin = rememberMe;
  },
  methods: {
    activateAccount: function () {
      this.$store.commit('changeParentVerification', {
        juniorId: (this.frozenResponse as any).personId,
        firstName: (this.frozenResponse as any).firstName,
        lastName: (this.frozenResponse as any).lastName
      });

      this.$router.push('/parent-member');
    },
    processLogin: async function (res: any) {
      const decoded: any = decodeToken(res.token);
      const event = new CustomEvent("userLoaded", {
        detail: { personId: decoded.nameid, token: res.token },
      });
      window.dispatchEvent(event);

      localStorage.setItem("userToken", res.token);
      const redirect = this.$route.query.redirect;
      const destination = typeof redirect === "string" && redirect.startsWith("/") && !redirect.startsWith("//")
        ? redirect
        : "/";
      this.$router.push(destination);
    },
    submit: function () {
      this.errorMessage = '';
      this.isError = false;
      this.isProcessing = true;
      localStorage.setItem("rememberMe", JSON.stringify(this.rememberLogin));
      authenticationService
        .login({
          username: this.username,
          password: this.password,
          rememberLogin: this.rememberLogin,
        })
        .then((res) => {
          this.isProcessing = false;
          if(!res){            
            this.errorMessage = "There was a connection error, try again. If the problem persists, please contact the ASCA Business Office at support@asca.org.";
            this.isError = true;
          }
          else {
              if (res.status === 401) {
              this.isError = true;
              this.errorMessage = "Username and/or password invalid"
            } else if (res && res.stack && res.message) {
              this.isError = true;
              this.errorMessage = res.message;
            } else if (res.token) {
              this.processLogin(res);
            } else if (res.frozen) {
              this.isFrozen = true;
              this.frozenResponse = res;
            }
          }
        })
        .catch((e) => {
          if (!!e && e.message) {
            this.errorMessage = e.message;
            this.isError = true;
          } else {
            this.errorMessage = "An unknown error occurred.";
            this.isError = true;
          }
        });
    },
  },
});
</script>
